import {
  FETCH_COLLECTIONS,
  TOGGLE_MAIN_RING_COLLECTIONS,
  TOGGLE_HOLDER_RING_COLLECTIONS,
} from "../actions/types";

const INITIAL_STATE = {
  collectionsList: null,
  selectedMainRingCollections: [],
  selectedHolderRingCollections: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COLLECTIONS:
      return { ...state, collectionsList: action.payload };
    case TOGGLE_MAIN_RING_COLLECTIONS:
      let mainRingCollections = state.selectedMainRingCollections;
      const ringIndex = mainRingCollections.indexOf(action.payload);
      if (ringIndex > -1) {
        mainRingCollections.splice(ringIndex, 1);
      } else {
        mainRingCollections.push(action.payload);
      }

      return {
        ...state,
        selectedMainRingCollections: [...mainRingCollections],
      };
    case TOGGLE_HOLDER_RING_COLLECTIONS:
      let holderRingCollections = state.selectedHolderRingCollections;
      const holderIndex = holderRingCollections.indexOf(action.payload);
      if (holderIndex > -1) {
        holderRingCollections.splice(holderIndex, 1);
      } else {
        holderRingCollections.push(action.payload);
      }

      return {
        ...state,
        selectedHolderRingCollections: [...holderRingCollections],
      };
    default:
      return state;
  }
};
